import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function SupportUs() {
  return <section data-section-id="193025" id="cta-still-have-questions" className="relative py-24 md:py-32 lg:py-40 overflow-hidden flex items-center justify-center min-h-[60vh] bg-background text-foreground">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1590442/img/muted_eyeglasses_background.png)] bg-cover bg-center opacity-20" aria-hidden="true" />
      
      {}
      <div className="absolute inset-0 bg-background/80 backdrop-blur-sm" aria-hidden="true" />

      {}
      <div className="relative z-10 container mx-auto px-4 md:px-6 max-w-3xl text-center">
        <h2 className="font-bold tracking-tight text-primary mb-6 !text-5xl">Still have questions?</h2>
        
        <p className="text-lg md:text-xl text-foreground/90 mb-10 max-w-2xl mx-auto font-sans">Our team typically replies within 24 hours. Tell us your idea and we'll help you figure out the best way to get started.</p>

        {}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6">
          <Button asChild size="lg" className="w-full sm:w-auto h-14 px-8 text-base font-semibold rounded-lg active:scale-[0.98] transition-transform duration-200 shadow-none bg-primary text-primary-foreground hover:opacity-90">
            <Link to="/ContactPage">
              Get in Touch
            </Link>
          </Button>
          
          <Button asChild variant="outline" size="lg" className="w-full sm:w-auto h-14 px-8 text-base font-semibold rounded-lg active:scale-[0.98] transition-transform duration-200 bg-card border-border text-foreground hover:bg-muted hover:text-foreground shadow-none">
            <Link to="/HowItWorksFAQPage">View Models</Link>
          </Button>
        </div>
      </div>
    </section>;
}